import produce from "immer";
import React, { FC, useRef } from "react";
import { useDrop } from "react-dnd";
import { useDispatch, useSelector } from "react-redux";
import { startAddElement } from "../../../../actions/elementListAction";
import { TabelCell } from "../../../../models/tabelCellModel";
import { getElementTemplates } from "../../../../selectors/appSelectors";
import { getAllElements, getElementsByCellId } from "../../../../selectors/elementListSelector";
import { ItemTypes } from "../../../../utils/itemTypes";
import RenderElement from "../../RenderElement";
import { Tooltip } from "react-tippy";
import missingNumberFunc from "../../../utilComponents/elementNameGeneratingComponent";

export interface TabelCellElementProps {
  cell: TabelCell;
  sectionId: String;
  formId: String;
  isPreview?: boolean;
  tableTheam: String;
}

const TabelCellElement: FC<TabelCellElementProps> = ({
  cell,
  sectionId,
  formId,
  isPreview = false,
  tableTheam,
}) => {
  const dispatch = useDispatch();
  const ref = useRef<HTMLDivElement>(null);
  const cellElement = useSelector(getElementsByCellId(cell.id));
  const elementState = useSelector(getAllElements);
  const elementTemplateState = useSelector(getElementTemplates);
  const renderElementList = () => {
    return cellElement.map((element: any, i: number) => {
      return (
        <RenderElement
          index={i}
          key={`${element.id}`}
          element={element}
          isPreview={isPreview}
        />
      );
    });
  };

  const addElement = (elementType: string, tabsCount: number) => {
    const elemetTemplate = elementTemplateState.filter((elementTemplate) => {
      if (elementTemplate.type === elementType) {
        return elementTemplate;
      }
    });
    //filter and sort relevent element list
    const elementListCount = elementState.present.filter((elementList) => {
      if (elementList.type === elementType) {
        return elementList;
      }
    }).sort((a, b) => {
      return (a.sortKey > b.sortKey) ? 1 : -1
    });

    //get missing number
    const missingNumber = missingNumberFunc(elementListCount.map((elementListNo) => {
      return elementListNo.sortKey
    }))
    dispatch(
      startAddElement(
        {
          sectionId: sectionId,
          name: `Table_${produce(
            elemetTemplate[0].name,
            () => {}
          )}${missingNumber}`,
          formId: formId,
          cellId: cell.id,
          isSection: false,
          actions: [],
          type: elementType,
          colClass: "col-12",
          sortKey: missingNumber,
          properties: produce(elemetTemplate[0].properties, () => {}),
          styles: produce(elemetTemplate[0].styles, () => {}),
          createdTime: "",
          lastUpdatedTime: "",
        },
        tabsCount
      )
    );
  };

  const [{ isOver, isOverCurrent }, drop] = useDrop({
    accept: [ItemTypes.ELEMENT],
    drop(item: any, monitor) {
      const itemType = monitor.getItemType();
      if (itemType === ItemTypes.ELEMENT) {
        const didDrop = monitor.didDrop();
        if (didDrop) {
          return;
        }
        addElement(item.type, 0);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      isOverCurrent: monitor.isOver({ shallow: true }),
    }),
    hover(item: any, monitor) {
      const hoverType = monitor.getItemType();
    },
  });

  drop(ref);
  const backGroundHover = isOver ? "drop-hover-tab" : "";
  const width = cell.properties.width ?? cell.properties.width + "px";
  const height = cell.properties.height ?? cell.properties.height + "px";
  const colClass = cell.properties.displayInline ? "col d-flex" : "col";
  return (
    <td key={`${cell.id}`} className={cell.class} width={width} height={height} style={{borderBottom: tableTheam === "table-borderless" || tableTheam === undefined || tableTheam === "" ? '0px' : '', borderTop: tableTheam === "table-borderless" || tableTheam === undefined || tableTheam === "" ? '0px' : ''}}>
      <div
        ref={ref}
        key={`${cell.id}`}
        className={`row ${backGroundHover}`}
        style={{ minHeight: isPreview ? "" : "50px" }}
      >
        <div className={colClass}>
          {renderElementList()}
          {!isPreview && (
            <Tooltip title="Select table cell">
              <div
                style={{
                  textAlign: "end",
                  position: "absolute",
                  bottom: "0px",
                  right: "2px",
                  fontSize: "10px",
                  width: "10px",
                }}
              >
                <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
              </div>
            </Tooltip>
          )}
        </div>
      </div>
    </td>
  );
};

export default TabelCellElement;
